import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { APP_ROUTES } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@shared/interceptors/auth.interceptor';
import { loaderInterceptor } from '@shared/interceptors/loader.interceptor';
import { errorInterceptor } from '@shared/interceptors/error.interceptor';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideEnvironmentNgxMask } from 'ngx-mask'

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentNgxMask(),
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptors([authInterceptor, loaderInterceptor, errorInterceptor])),
    importProvidersFrom([NgxDaterangepickerMd.forRoot()]),
    { provide: LOCALE_ID, useValue: 'en-US' }
    // {provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: {timezone: 'UTC+0000'}} //TODO, todo_timezone change when site wide setup for timezone
  ],
};
